// home.js
import React from 'react';

import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import History from './History';
import { Resume } from './Resume/Resume';
import ChartsDataProvider from './Resume/contexts/ChartsDataContext';

const Documentations = ({ activeTab, setActiveTab, showNav }) => {
    return (
        <div
            className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >
            {showNav && (
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'resume'
                            })}
                            onClick={() => {
                                setActiveTab('resume');
                            }}
                        >
                            Resumo
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'history'
                            })}
                            onClick={() => {
                                setActiveTab('history');
                            }}
                        >
                            Extrato
                        </NavLink>
                    </NavItem>
                </Nav>
            )}
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="resume">
                    <Col sm="12">
                        <ChartsDataProvider>
                            <Resume />
                        </ChartsDataProvider>
                    </Col>
                </TabPane>
                <TabPane tabId="history">
                    <Col sm="12">
                        <History />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
};

export default Documentations;
